import { styled, useMediaQuery, useTheme } from '@mui/material';
import { I18nStore } from '@tools/i18n/store';
import { useSetLocaleFromUrl } from '@tools/routes';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';

import { Spinner } from '../spinner';
import { SignupLogo } from './logo';
import { SignupSidebar } from './sidebar';

const Wrapper = styled('div')({
    backgroundColor: '#f3f5f6',
    minHeight: '100vh',
    display: 'flex'
});

const Scrollable = styled('div')({
    height: '100vh',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
});

const Main = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    flexGrow: 1,
    alignSelf: 'stretch',
    padding: '40px 20px',
    [theme.breakpoints.up('sm')]: {
        margin: '30px',
        padding: '30px'
    },
    [theme.breakpoints.up('md')]: {
        margin: '50px'
    },
    [theme.breakpoints.up('lg')]: {
        flexGrow: 0,
        alignSelf: 'center',
        width: 'calc(100% - 100px)',
        maxWidth: '1500px',
        padding: '50px'
    }
}));

const SpinnerContainer = styled('div')({
    minHeight: '300px'
});

export const SignupPageLayout = observer(
    ({ children }: { children: React.ReactNode }) => {
        const { translationsReady } = injectTSDI(I18nStore);
        const theme = useTheme();
        const largeScreens = useMediaQuery(theme.breakpoints.up('lg'));

        useSetLocaleFromUrl();

        return (
            <Wrapper>
                {largeScreens && <SignupSidebar />}
                <Scrollable>
                    <Main>
                        <SignupLogo />
                        {translationsReady ? (
                            children
                        ) : (
                            <SpinnerContainer>
                                <Spinner size={70} />
                            </SpinnerContainer>
                        )}
                    </Main>
                </Scrollable>
            </Wrapper>
        );
    }
);
